import * as Immutable from "immutable";
import Direction from "views/logic/aggregationbuilder/Direction";
export default class InvestigationsWidgetSortConfig {
  constructor(field, direction) {
    this._value = { field, direction };
  }
  get field() {
    return this._value.field;
  }
  get direction() {
    return this._value.direction;
  }
  toJSON() {
    const { field, direction } = this._value;
    return {
      field,
      direction
    };
  }
  static fromJSON(value) {
    const { field, direction } = value;
    return new Builder().field(field).direction(Direction.fromJSON(direction)).build();
  }
  toBuilder() {
    const { field, direction } = this._value;
    return new Builder(Immutable.Map({ field, direction }));
  }
}
export class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  field(value) {
    return new Builder(this.value.set("field", value));
  }
  direction(value) {
    return new Builder(this.value.set("direction", value));
  }
  build() {
    const { field, direction } = this.value.toObject();
    return new InvestigationsWidgetSortConfig(field, direction);
  }
}
